'use strict'

import $ from 'jquery';
window.jQuery = $
window.$ = $

import 'bootstrap';
import 'rangeslider.js';

const PRICE = 46
const COUNT_CAP = 101
const COUNT_MIN = 5

$(() => {
  var $price = $('#pricing-base-price')
  var $quote = $('#pricing-slider-quote')
  var $count = $('#pricing-slider-count')

  var $cta_demo = $('#btn-demo')
  var $cta_signup = $('#btn-signup')

  $price.text(PRICE)
  $count.text(COUNT_MIN)
  $quote.text('$' + (COUNT_MIN * PRICE) + '/mo')

  $('input[type="range"]').rangeslider({
    polyfill: false,
    max: COUNT_CAP,
    min: COUNT_MIN,
    onSlide: (pos, value) => {
      if (value >= COUNT_CAP) {
        $count.text(COUNT_CAP + '+')
        $quote.text('Contact Us')
        $cta_demo.css('display', 'block')
        $cta_signup.css('display', 'none')
      } else {
        if (value > 50) {
          // We want to price in buckets of 5 up to 50, then buckets of 10 up to 100
          // This will round 55 up to 60, etc
          value = Math.ceil(value / 10) * 10
        }
        $count.text(value)
        $quote.text('$' + (value * PRICE) + '/mo')
        $cta_demo.css('display', 'none')
        $cta_signup.css('display', 'block')
      }
    }
  })

  $('[data-toggle="tooltip"]').tooltip()
})
